<template>
  <main class="bmd-layout-content">
    <div class="container mt-3">
      <div class="col-12 d-sm-inline-flex justify-content-end">
        <div class="btn btn-outline btn-block mt-2 mr-2 col-md-3" data-toggle="collapse"
             data-target="#collapseCrearContenido"
             aria-expanded="false"
             aria-controls="collapseCrearContenido" v-if="acciones.editar">Editar
          contenidos
        </div>
        <div class="btn btn-outline btn-block mt-2 mr-2 col-md-3" data-toggle="collapse"
             data-target="#collapseCrearContenido"
             aria-expanded="false"
             aria-controls="collapseCrearContenido" v-else>Crear contenidos
        </div>
        <div class="btn btn-outline btn-block mt-2 col-md-3" data-toggle="collapse" data-target="#collapseExample"
             aria-expanded="true"
             aria-controls="collapseExample">Listar contenidos
        </div>
      </div>

      <div class="collapse mt-2" id="collapseCrearContenido">
        <div class="card card-body" style="background-color: rgba(255,255,255,0.31)">
          <div class="row mx-0 px-0">
            <div class="form-group col-12 col-md-6  mx-0 px-0 order-1 order-md-0">
              <label for="formGroupExampleInput">Titulo del contenido</label>
              <input type="text" class="form-control" id="formGroupExampleInput" placeholder="Ingrese el titulo"
                     v-model="contenido.titulo">
            </div>
          </div>
          <select class="custom-select custom-select-sm col-12 pb-0 mb-0" v-model="selectCategoria" placeholder="ola">
            <option selected value="Escoger categoria">Seleccionar categoria</option>
            <option v-for="categoria in listaCategorias[0]" v-bind:value="categoria.id">{{categoria.categoria}}</option>
          </select>
          <button class="btn btn-default border text-left btn-sm mb-0" type="button" data-toggle="collapse"
                  data-target="#collapseSelectEtiqueta"
                  aria-expanded="false" aria-controls="multiCollapseExample2">S<span
            class="text-lowercase">eleccionar etiquetas <small>(opcional)</small></span>
          </button>
          <div :class="collapseEtiqueta" :id="colapsado">
            <select class="custom-selectpt-0 col-12 mt-0" v-model="etiquetaSeleccionada.selected" multiple size="5">
              <option value="null">Ninguna</option>
              <option v-for="etiqueta in listaCategorias[1]" :value="etiqueta.id">{{etiqueta.etiqueta}}</option>
            </select>
          </div>
          <vue-editor
            :editorOptions="editorSettings"
            v-model="contenido.contenido">
          </vue-editor>
          <div class="col-12 text-muted font-weight-bold">vista previa</div>
          <div class="card card-body" v-html="contenido.contenido"></div>
          <div class="col-12 mx-0 px-0 d-inline-flex">
            <div class="btn btn-outline mt-2 col-md-2 mr-2" @click="editar()" v-if="acciones.editar">Actualizar</div>
            <div class="btn btn-outline mt-2 col-md-2 mr-2" @click="publicar()" v-else>Guardar</div>
            <div class="btn btn-outline mt-2 col-md-2" @click="limpiar()">Cancelar</div>
          </div>
        </div>
      </div>
      <hr>
      <div class="collapse mt-2 mb-5" id="collapseExample" aria-expanded="false">
        <div class="card card-body" style="background-color: rgba(255,255,255,0.31)">
          <listarContenido></listarContenido>
        </div>
      </div>
      <hr>
      <div class="mt-2 mb-5">
        <div class="card card-body" style="background-color: rgba(255,255,255,0.31)">
          <h5 class="pl-2 text-muted text-uppercase" style="font-size: medium">Ordenar mas ayudas</h5>
          <masAyudas></masAyudas>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
  import {VueEditor} from "vue2-editor";
  import servicioApi from '../../servicioApi';
  import masAyudas from './componentes/masAyudas';

  import listarContenido from './componentes/listarContenido'

  export default {
    name: "contenido",
    components: {VueEditor, listarContenido, masAyudas},
    data() {
      return {
        contenido: {contenido: '', titulo: ''},
        selectCategoria: 'Escoger categoria',
        listaCategorias: {},
        editorSettings: {
          modules: {
            imageDrop: true
          }
        },
        acciones: {editar: false},
        etiquetasDeCategorias: {},
        collapseEtiqueta: 'collapse',
        etiquetaSeleccionada: {
          selected: []
        },
      }
    },
    created() {
      this.cargarContenido();
      $(function () {
        $('#collapseCrearContenido').collapse('hide');
        $('#collapseExample').collapse('show');
      });

      servicioApi.rol_regular.categorias.getListarCategorias().then(resp => {
        this.listaCategorias = resp.data.data;
        EventBus.$emit("listcategorias",this.listaCategorias[0]);
      });
    },
    mounted() {
      EventBus.$on('editarContenido', data => {
          this.acciones.editar = true;
          this.contenido.titulo = data.titulo;
          this.selectCategoria = data.categoria_id;
          this.contenido.id = data.id;
          servicioApi.rol_regular.contenidos.getUnContenidos(data.id).then(resp => {
            this.contenido.contenido = resp.data.data.contenido;
            this.selectCategoria = resp.data.data.categoria_id;
            $('#collapseCrearContenido').collapse('show');
          });
        }
      )
    },
    computed: {
      colapsado: function () {
        if (this.selectCategoria != 'Escoger categoria') {
          servicioApi.rol_regular.categorias.getEtiquetasDeUnaCategorias(this.selectCategoria).then(resp => {
            console.log(resp);
            this.etiquetasDeCategorias = resp.data.data;
          }).catch(e => {
          });
          this.collapseEtiqueta = 'collapse';
          return "collapseSelectEtiqueta";
        }
        if (this.selectCategoria == 'Escoger categoria') {
          this.collapseEtiqueta = 'collapse hide';
          return "";
        }
      }
    },
    methods: {
      publicar: function () {
        if (this.validarCampos()) {
          this.contenido.categoria_id = this.selectCategoria;
          this.contenido.etiquetas = this.etiquetaSeleccionada.selected;
          servicioApi.rol_regular.contenidos.postContenidos(this.contenido).then(resp => {
            this.limpiar();
            EventBus.$emit('cargarContenidos', true);
          });

          servicioApi.rol_regular.masAyudas.getMasAyudas(this.contenido.categoria_id).then(resp=>{
            console.log(resp)
          }).catch(e=>{console.log(e)});
        }
      },
      cargarContenido: function () {
        servicioApi.rol_regular.contenidos.getContenidos({page: 1, mostrar: 10}).then(resp => {
          EventBus.$emit('listaContenidos', resp.data.data);
        }).catch(e => {
        });
      },
      editar: function () {
        if (this.validarCampos()) {
          this.contenido.categoria_id = this.selectCategoria;
          this.contenido.etiquetas = this.etiquetaSeleccionada.selected;
          if (this.contenido.etiquetas == '')
            this.contenido.etiquetas = null;
          console.log(this.contenido.etiquetas)
          servicioApi.rol_regular.contenidos.putContenidos(this.contenido).then(resp => {
            this.limpiar();
            EventBus.$emit('cargarContenidos', true);
            // console.log(resp.data.data.categoria_id)
          });
          servicioApi.rol_regular.masAyudas.getMasAyudas(this.selectCategoria).then(resp=>{
            console.log(resp)
          }).catch(e=>{console.log(e)});;
        }
      },
      desplegarSelectEtiqueta: function () {
        if (this.selectCategoria == 'Escoger categoria')
          alert('para asignar etiquetas debe seleccionar una categoria');
        if (this.selectCategoria != 'Escoger categoria')
          servicioApi.rol_regular.categorias.getEtiquetasDeUnaCategorias(this.selectCategoria).then(resp => {
            console.log(resp);
            this.etiquetasDeCategorias = resp.data.data;
          }).catch(e => {
          });
      },
      limpiar: function () {
        $('#collapseCrearContenido').collapse('hide');
        this.contenido = {contenido: '', titulo: ''};
        this.selectCategoria = 'Escoger categoria';
        this.acciones.editar = false;
      },
      validarCampos: function () {
        if (this.contenido.titulo == '' || this.contenido.titulo == null || this.contenido.titulo == undefined)
          alert('Ingrese un titulo');
        else if (this.selectCategoria == 'Escoger categoria')
          alert('Escoger una categoria');
        else if (this.contenido.contenido == '' || this.contenido.contenido == null || this.contenido.contenido == undefined)
          alert('Ingrese el contenido');
        else {
          return true;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .bmd-layout-content {
    min-height: 90vh;
  }

  /* .bmd-form-group {
     position: relative;
     padding-top: 0 !important;
   }*/

  .custom-select:focus {
    background-size: 8px 10px;
    border: 1px solid rgba(0, 0, 0, .26);
    border-radius: .125rem;
    -webkit-appearance: none;

    border-color: rgba(0, 0, 0, .26);
    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(23, 255, 233, 0);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(23, 255, 233, 0);
  }
</style>



// WEBPACK FOOTER //
// src/components/privada/regular/contenido/contenido.vue